/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-attribute-type.reducer';

export const PatientAttributeTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientAttributeTypeEntity = useAppSelector(state => state.patientAttributeType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientAttributeTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientAttributeType.detail.title">PatientAttributeType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.cursor}</dd>
          <dt>
            <span id="title">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.title">Title</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.title}</dd>
          <dt>
            <span id="unitsOfMeasure">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.unitsOfMeasure">Units Of Measure</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.unitsOfMeasure}</dd>
          <dt>
            <span id="valueType">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.valueType">Value Type</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.valueType}</dd>
          <dt>
            <span id="valueRange">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.valueRange">Value Range</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.valueRange}</dd>
          <dt>
            <span id="group">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.group">Group</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.group}</dd>
          <dt>
            <span id="isReqForRegistration">
              <Translate contentKey="tinyMedicRestApp.patientAttributeType.isReqForRegistration">Is Req For Registration</Translate>
            </span>
          </dt>
          <dd>{patientAttributeTypeEntity.isReqForRegistration ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAttributeType.specialty">Specialty</Translate>
          </dt>
          <dd>{patientAttributeTypeEntity.specialty ? patientAttributeTypeEntity.specialty.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAttributeType.hospital">Hospital</Translate>
          </dt>
          <dd>{patientAttributeTypeEntity.hospital ? patientAttributeTypeEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAttributeType.parent">Parent</Translate>
          </dt>
          <dd>{patientAttributeTypeEntity.parent ? patientAttributeTypeEntity.parent.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAttributeType.clinicalDictionaryType">Clinical Dictionary Type</Translate>
          </dt>
          <dd>{patientAttributeTypeEntity.clinicalDictionaryType ? patientAttributeTypeEntity.clinicalDictionaryType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-attribute-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-attribute-type/${patientAttributeTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientAttributeTypeDetail;
